import { ShareBtnComponent } from './share-btn.component';
import { runClientComponent } from '../../_common/client/client-component-runner';

runClientComponent({ ShareBtnComponent });
